// extracted by mini-css-extract-plugin
var _1 = "UnderskinQuestion_descriptionContainer__U8qic";
var _2 = "UnderskinQuestion_imageContainer__9h8qZ";
var _3 = "768px";
var _4 = "'../../../../shared.module.css'";
var _5 = "UnderskinQuestion_underskinColorQuestionContainer__LeJ7z";
export { _1 as "descriptionContainer", _2 as "imageContainer", _3 as "md", _4 as "shared", _5 as "underskinColorQuestionContainer" }
